/**
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder
 * In case we want to use modulo operation because JS '%' symbol is reserved for remainder operation
 */
export const mod = (n: number, d: number): number => ((n % d) + d) % d;
